/********* utils.js ************** */
// some heklper functions that get imported into other scripts

const removeItem = item => {
  item.parentElement.removeChild(item);
}

const trimPrice = price => {
  // test if price string has '.0' on the end
  // and trim if it does
  if (price.slice(-2) === '.0') {
    return price.slice(0, -2);
  } else {
    return price;
  }
}

const stripFirstWord = str => {
  // used in report table
  return str.substr(str.indexOf(" ") + 1);
}

const formatTrimmedCurrency = str => {
  let trimmed = trimPrice(str);
  return trimmed.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const fetchText = async (url, target) => {
  let response = await fetch(url);
  // console.log(response.status); // 200
  // console.log(response.statusText); // OK

  if (response.status === 200) {
      let data = await response.text();
      target.innerHTML = data;
  }
}

export { removeItem, trimPrice, formatTrimmedCurrency, stripFirstWord, fetchText};